<div class="flex flex-row gap-16 items-end w-full max-w-[142rem] py-[15rem] min-h-[100rem] mx-auto">
  <div class="relative flex flex-row items-end w-8/12">
    <div class="relative z-10 flex flex-col gap-60">
      <h3
        class="font-extrabold text-[9rem] leading-[8rem] text-base-font-primary"
        [innerHTML]="'education-levels.title' | translate"
      ></h3>
      <div class="flex justify-start 3xl:-space-x-12 -space-x-14">
        <img
          class="w-48 cursor-pointer saturate-0 hover:saturate-50"
          [ngStyle]="{ zIndex: l - i }"
          [ngClass]="{ 'filter-none hover:filter-none': isActive(i) }"
          *ngFor="let thumb of levels; let i = index; let l = count"
          loading="lazy"
          [src]="thumb.thumbnail"
          [alt]="thumb.name"
          (click)="onToggleActive(i)"
        />
      </div>
    </div>
    <div class="h-[52rem] 3xl:h-[56rem] w-[52rem] 3xl:w-[56rem] absolute right-0 z-0">
      <ng-container *ngFor="let level of levels; let i = index">
        <img
          loading="lazy"
          class="w-[94%] 3xl:w-full absolute bottom-0 right-20 [clip-path:polygon(0_0,100%_0,100%_60%,0_60%)] opacity-0 ease-in-out duration-300"
          [ngClass]="{ '!opacity-100 !right-0': isActive(i) }"
          [src]="level.img"
          [alt]="level.name"
        />
      </ng-container>
      <div
        class="bg-base-blue-light -z-10 h-[52rem] 3xl:h-[56rem] overflow-hidden relative rounded-full w-[52rem] 3xl:w-[56rem] ease-in-out duration-500"
        [ngClass]="'bg-base-' + levels[activeLevel].color"
      >
        <ng-container *ngFor="let level of levels; let i = index">
          <img
            loading="lazy"
            class="w-[94%] 3xl:w-full absolute bottom-0 right-20 opacity-0 ease-in-out duration-300"
            [ngClass]="{ '!opacity-100 !right-0': isActive(i) }"
            [src]="level.img"
            [alt]="level.name"
          />
        </ng-container>
      </div>
    </div>
  </div>
  <div class="relative flex flex-col self-center w-4/12 gap-8">
    <ng-container *ngFor="let level of levels; let i = index">
      <h1
        class="font-extrabold text-[5rem] leading-none text-base-font-secondary ease-in-out duration-300 opacity-0 absolute bottom-24 left-0"
        [ngClass]="{ '!opacity-100 !bottom-4': isActive(i) }"
        [innerHTML]="level.name"
      ></h1>
      <p
        class="absolute left-0 text-2xl duration-300 ease-in-out opacity-0 text-base-font-primary top-24"
        [ngClass]="{ '!opacity-100 !top-4': isActive(i) }"
      >
        {{ level.text }}
      </p>
    </ng-container>
  </div>
</div>
